jQuery(document).foundation();
var $ = jQuery;

$(document).ready(function () {
  jQuery(document).foundation();
  removeNewsticker();
  $(window).resize(function () {
    removeNewsticker();
    checkWidths();
  });
  checkWidths();
  if ($('#slider:not(.normal)').length > 0) {
    // Bei der Initialisierung die Position der slick-dots anpassen
    $('#slider:not(.normal)').on('init', function(event, slick) {
      var $currentSlide = $(slick.$slider).find('.slick-current');
      adjustDotsPosition(slick.$slider, $currentSlide)
    });
    $('#slider:not(.normal)').slick({
      autoplay: false,
      autoplaySpeed: 5000,
      dots: true,
      arrows: true,
      adaptiveHeight: true,
    });
    
    // Funktion zur Anpassung der slick-dots Position
    function adjustDotsPosition(slider, $currentSlide) {
      
      var $description = $currentSlide.find('.slider-description');
      if ($description.length) {
        var descriptionHeight = $description.outerHeight();
        if(window.innerWidth > 640){var additionalOffset = 14;}else{var additionalOffset = 12;}
        var dots = $(slider).find('.slick-dots');
        
        // Setze die Position der slick-dots basierend auf der Höhe der Beschreibung plus 0.5rem
        dots.css('bottom', (descriptionHeight + additionalOffset) + 'px');
      }else{
        if(window.innerWidth > 640){var additionalOffset = 14;}else{var additionalOffset = 16;}
        var dots = $(slider).find('.slick-dots');
        dots.css('bottom', (additionalOffset) + 'px');
      }
   

    

    // Bei jedem Slide-Wechsel die Position der slick-dots anpassen
    $('#slider:not(.normal)').on('afterChange', function(event, slick, currentSlide) {
      var $currentSlide = $(slick.$slider).find('.slick-current');
      adjustDotsPosition(slick.$slider, $currentSlide);
    });

        // Beim Fenster-Resize die Position der slick-dots neu berechnen
        $(window).resize(function () {
          var slickSlider = $('#slider:not(.normal)');
          if (slickSlider && slickSlider.hasClass('slick-initialized')) { // Prüfen, ob der Slider bereits initialisiert ist
            var $currentSlide = $(slickSlider).find('.slick-current');
            adjustDotsPosition(slickSlider, $currentSlide);
          }
        });
      }
  }
  if ($('#slider.normal').length > 0) {
    // Bei der Initialisierung die Position der slick-dots anpassen
    $('#slider.normal').on('init', function(event, slick) {
      var $currentSlide = $(slick.$slider).find('.slick-current');
      adjustDotsPositionNormal(slick.$slider, $currentSlide)
    });
    $('#slider.normal').slick({
      autoplay: false,
      autoplaySpeed: 5000,
      dots: true,
      arrows: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            adaptiveHeight: true,
            arrows: true,
          }
        }
      ]
    });
    // Funktion zur Anpassung der slick-dots Position
    function adjustDotsPositionNormal(slider, $currentSlide) {
      if(window.innerWidth > 640){
        var $description = $currentSlide.find('.slider-description');
        if ($description.length) {
          var descriptionHeight = $description.outerHeight();
          var additionalOffset = 14;
          var dots = $(slider).find('.slick-dots');
          
          // Setze die Position der slick-dots basierend auf der Höhe der Beschreibung plus 0.5rem
          dots.css('bottom', (descriptionHeight + additionalOffset) + 'px');
          $description.css('margin-top', '-' + (descriptionHeight + 1) + 'px');
        }
        else{
          var additionalOffset = 16;
          var dots = $(slider).find('.slick-dots');
          dots.css('bottom', (additionalOffset) + 'px');
        }
      }else{
        var additionalOffset = 12;
        var dots = $(slider).find('.slick-dots');
        var $description = $currentSlide.find('.slider-description');
         var descriptionHeight = $description.outerHeight();
         if ($description.length){
          dots.css('bottom', (additionalOffset + descriptionHeight) + 'px');
          $description.css('margin-top', '0px');
         }else{
          var additionalOffset = 16;
          dots.css('bottom', (additionalOffset) + 'px');
         }
        
      }
      
      

    }

    

    // Bei jedem Slide-Wechsel die Position der slick-dots anpassen
    $('#slider.normal').on('afterChange', function(event, slick, currentSlide) {
      var $currentSlide = $(slick.$slider).find('.slick-current');
      adjustDotsPositionNormal(slick.$slider, $currentSlide);
    });

    // Beim Fenster-Resize die Position der slick-dots neu berechnen
    $(window).resize(function () {
      var slickSlider = $('#slider.normal');
      if (slickSlider && slickSlider.hasClass('slick-initialized')) { // Prüfen, ob der Slider bereits initialisiert ist
        var $currentSlide = $(slickSlider).find('.slick-current');
        adjustDotsPositionNormal(slickSlider, $currentSlide);
      }
    });
  }
  $(".wpcf7-form-control").removeAttr("size");
  $(".wpcf7-form-control-wrap").css("display", "block");
  adjustWidths();
  if ($('.veranstaltungen-filter')) {
    $('.veranstaltungen-filter').css('visibility', 'visible');
  }
  if ($('.newsticker')) {
    $('.newsticker').css('visibility', 'visible');
  }
  if ($('.newsticker-placeholder')) {
    $('.newsticker-placeholder').css('visibility', 'visible');
  }








  // Kalender Filter Checkboxen
  $('.veranstaltungen-filter-kategorien, .veranstaltungen-filter-orte').on("click", "li", function (e) {
    var filter = $(this).find("[type=checkbox]");

    var check_prop = false;

    if (!filter.prop("checked")) {
      check_prop = true;
    }
    else {
      check_prop = false;
    }

    // set Checkboxes of Filter Category
    $(filter).parent().find("[type=checkbox]").each(function () {
      $(this).prop('checked', check_prop);
    });

    if (!filter.prop("checked")) {
      $(".checkbox-" + filter.attr("id")).prop('checked', false);
    } else {
      $(".checkbox-" + filter.attr("id")).prop('checked', true);
    }



  
        updateFilter();
        updateCalendar();
    

    e.stopPropagation();
    e.preventDefault();

  });

  function updateFilter(){
    let filterusedkat = true;
    let filterusedort = true;

    let allKatChecked = true;
    let allKatUnchecked = true;

    $('.veranstaltungen-filter-kategorien').find("[type=checkbox]").each(function(){
        if ($(this).prop("checked")) {
            allKatUnchecked = false;
        } else {
            allKatChecked = false;
        }
    });

    if (allKatChecked || allKatUnchecked) {
        filterusedkat = false;
    }

    let allOrtChecked = true;
    let allOrtUnchecked = true;

    $('.veranstaltungen-filter-orte').find("[type=checkbox]").each(function(){
        if ($(this).prop("checked")) {
            allOrtUnchecked = false;
        } else {
            allOrtChecked = false;
        }
    });

    if (allOrtChecked || allOrtUnchecked) {
        filterusedort = false;
    }

    $("#event-list-container-accordion .accordion-item").each(function () {
        $(this).removeClass('visiblebyfilter');

        let active = true;

        let ortevisible = false;
        let categoryvisible = false;

        let orteavailable = false;
        let categoryavailable = false;

        $($(this).attr('class').split(/\s+/)).each(function () {
            var class_item = this; //jede Klasse einmal anschauen
            if (
                class_item != "accordion-item" &&
                class_item != "is-active" &&
                class_item != "highlight" &&
                class_item != "normal" &&
                class_item.substring(0, 4) != "date") {
                active = false;

                $(".veranstaltungen-filter-orte").find("#" + class_item).each(function(){
                    orteavailable = true;

                    if($(this).prop('checked')){
                        ortevisible = true;
                    }     
                });
                $(".veranstaltungen-filter-kategorien").find("#" + class_item).each(function(){
                    categoryavailable = true;
                    if($(this).prop('checked')){
                        categoryvisible = true;
                    }     
                });
            }
        });  

        // Überprüfe die Sichtbarkeit basierend auf den Filterbedingungen
        if (filterusedkat && filterusedort) {
            // Wenn beide Filter verwendet werden, müssen sowohl der Ortsfilter als auch der Kategorienfilter die Veranstaltung sichtbar machen
            if ((categoryvisible && ortevisible) || (!categoryavailable && ortevisible) || (!orteavailable && categoryvisible)) {
                active = true;
            } else {
                active = false;
            }
        } else if (filterusedkat && !filterusedort) {
            // Wenn nur der Kategorienfilter verwendet wird, basiert die Sichtbarkeit nur auf dem Kategorienfilter
            if ((categoryvisible || !categoryavailable) && categoryavailable) {
                active = true;
            } else {
                active = false;
            }
        } else if (!filterusedkat && filterusedort) {
            // Wenn nur der Ortsfilter verwendet wird, basiert die Sichtbarkeit nur auf dem Ortsfilter
            if (ortevisible || !orteavailable) {
                active = true;
            } else {
                active = false;
            }
        } else {
            // Wenn kein Filter verwendet wird, sind alle Veranstaltungen sichtbar
            active = true;
        }

        if (active) {
            $(this).addClass('visiblebyfilter');

            // Wenn es sich um einen Blogbeitrag oder einen Komplizen handelt, trotzdem ausblenden, außer wenn alle Filter aktiv sind
            if(!$(this).hasClass('cal') && (filterusedkat || filterusedort)){
                $(this).removeClass('visiblebyfilter');
            }
        }
        if($(this).hasClass('cal') && !(filterusedkat || filterusedort)){
            $(this).addClass('visiblebyfilter');
        }
    });
}


function removeNewsticker(){
  if($(window).width() < 640){
    // Überprüfe, ob ein Element mit der Klasse '.newsticker' vorhanden ist
    if ($('.newsticker').length === 0) {
      // Wenn kein solches Element vorhanden ist, ändere die Margin top des Ziel-Elements
      $('.content').css('margin-top', '37.137rem');
    }
    else{
      $('.content').css('margin-top', '45.337rem');
    }
  }
  else{
    $('.content').css('margin-top', '12.5842rem'); // Ändere die Margin top auf 20px oder einen anderen Wert deiner Wahl
  }
  
}


function updateCalendar(){
$(".calendar-selection .day.active").each(function () {

date = $(this).attr('id');
$(this).removeClass('activebutfiltered');

activebutfiltered = true;
if($(this).hasClass("cur")){
  $(this).removeClass("cur");
  updateDate();
}

$("." + date).each(function(){
  if($(this).hasClass("visiblebyfilter")){
    activebutfiltered = false;
  }     
});

if(activebutfiltered){
  $(this).addClass('activebutfiltered');
}
});
}

// Kalender Datum Filter
$('.calendar-selection .day > a').click(function (e) {
e.preventDefault();
var params = {};
if ($(this).parent(".day").hasClass("cur")) {
$("#event-list-container-accordion .accordion-item").each(function () {
  
  $(this).removeClass('visiblebycalendar');

  if($(this).hasClass('visiblebydefault')){
    $(this).addClass('visiblebycalendar');
  }

    $(".day").removeClass("cur");

    updateFilter();
    updateCalendar();


});
}
else if ($(this).parent(".day").hasClass("active")) { //funktioniert nicht bei aktivem Filter für Veranstaltungen mit zwei Kategorien
// cur Klasse wecheln
$(".day").removeClass("cur");
$(this).parent(".day").addClass("cur");
var id = $(this).parent(".day").attr("id");
var datestring = $(this).parent(".day").attr("datestring");


// Scroll To Event
var target = $('#event-list-container-accordion .' + id);

// alten Tag ausblenden
$("#event-list-container-accordion .accordion-item").removeClass('visiblebycalendar');

// neuen Tag einblenden
$("#event-list-container-accordion .accordion-item[class*=" + id).each(function () {
    $(this).addClass('visiblebycalendar');


});

// Datum übergeben
params["date"] = $(".day.cur").attr("id");
}

});


  // Technikliste Checkboxen
  $('.checkliste-technik').on("click", "li", function (e) {
   
    var filter = $(this).find("[type=checkbox]");

    var check_prop = false;

    if (!filter.prop("checked")) {
      check_prop = true;
    }
    else {
      check_prop = false;
    }

    // set Checkboxes of Filter Category
    $(filter).parent().find("[type=checkbox]").each(function () {
      $(this).prop('checked', check_prop);
    });


    var params = {};

    $(".filter-wrapper").find("[type=checkbox]").each(function () {
      if (!this.checked) {
        params[$(this).attr("id")] = 1;
      }
    });


    //$("#more-events").attr("href", "/kalender/?" + $.param(params));

    if (!filter.prop("checked")) {
      $(".checkbox-" + filter.attr("id")).prop('checked', false);
    } else {
      $(".checkbox-" + filter.attr("id")).prop('checked', true);
    }

    var technikstring = "";
   
    $('.technikverleih-banner .checkliste-technik li input:checked').siblings('label').each(function(i, obj) {
     technikstring += $(this).text();
     technikstring += "\n";
    });
    
    $(".newsletter-formular #techniklistecheckbox").val(technikstring);

    

    e.stopPropagation();
    e.preventDefault();

  });

});

// Kalender Datum Filter
$('.calendar-selection .day > a').click(function (e) {
  e.preventDefault();
  var params = {};

  if ($(this).parent(".day").hasClass("active")) {
    // cur Klasse wecheln
    $(".day").removeClass("cur");
    $(this).parent(".day").addClass("cur");
    var id = $(this).parent(".day").attr("id");
    var datestring = $(this).parent(".day").attr("datestring");


    // Scroll To Event
    var target = $('#event-list-container-accordion .' + id);

    // alten Tag ausblenden
    $("#event-list-container-accordion .accordion-item").hide();

    // neuen Tag einblenden
    $("#event-list-container-accordion .accordion-item[class*=" + id).each(function () {
      let active = true;

      $($(this).attr('class').split(/\s+/)).each(function () {
        var class_item = this; //jede Klasse einmal anschauen
        if (
          class_item != "accordion-item" &&
          class_item != id &&
          class_item != "is-active" &&
          class_item != "highlight" &&
          class_item != "normal" &&
          class_item.substring(0, 4) != "date") {

          if (!$(".filter-wrapper").find("#" + class_item).prop('checked')) {
            active = false;
          }
        }
      });

      if (active) {
        $(this).show();
      }

    });

    // Datum übergeben
    params["date"] = $(".day.cur").attr("id");
  }
});





$(".technikliste-checkbox-input").change(function () {
  if (this.checked) {
    jQuery('.technikverleih-banner').css('opacity', 1);
    jQuery('.technikverleih-banner').css('pointer-events', 'inherit');
  }
  if ($(".technikliste-checkbox-input:checked").length == 0) {
    jQuery('.technikverleih-banner').css('opacity', 0);
    jQuery('.technikverleih-banner').css('pointer-events', 'none');
  }
});




$(window).resize(function () {
  adjustWidths();
});



function adjustWidths() {
  var messageheight = jQuery('.show-for-small-only .newsticker').outerHeight();
  jQuery('.main').css('padding-top', messageheight + 'px');
  jQuery('.veranstaltungen-filter').css('margin-top', messageheight + 'px');

  var filterheight = jQuery('.veranstaltungen-filter').outerHeight();
  jQuery('.events-content').css('padding-top', filterheight + 'px');
  

  var technikverleihbannerheight = jQuery('.technikverleih-banner').outerHeight();
  jQuery('.technikgrid').css('padding-bottom', technikverleihbannerheight + 'px');

  var mainwidth = $(".main").prop("clientWidth");
  jQuery('.veranstaltungen-filter').css('width', mainwidth + 'px');

  $("#event-list-container-accordion .accordion-content").each(function (index) {
    if (!$(this).find('.calendar-links').length) {
      $(this).css('padding-bottom', 0);
      $(this).css('padding-top', 0);
    }

  });
  var copyrightheight = jQuery('.kulturorte-entry-content .full-width-copyright-container').outerHeight();
  jQuery('.kulturorte').css('margin-top', '-' + copyrightheight + 'px');

}
  $(function(){
    var tickerLength = $('.newsticker-scroll .newsticker-container .line').outerWidth();
    $('.newsticker-scroll .newsticker-container .line:last-child').prependTo('.newsticker-scroll .newsticker-container');
    $('.newsticker-scrll .newsticker-container').css('marginLeft',-10);
    
    function moveTop(){
      $('.newsticker .newsticker-container').animate({
        left : -tickerLength
      },tickerLength*30, "linear",function(){
      $('.newsticker-scroll .newsticker-container .line:first-child').appendTo('.newsticker-scroll .newsticker-container');
      $('.newsticker-scroll .newsticker-container').css('left','');
      });
    }

    setInterval( function(){
      moveTop();
    }, 0);
});

function checkWidths() {
  if($(window).width() > 640){
    var element1 = $('.column-text');
    var element2 = $('.column-images');
    
    // Überprüfen, ob element1 gefunden wurde und die Länge größer als 0 ist
    if(element1.length > 0 && element2.length > 0){
      // Position von element1 relativ zum nächstgelegenen positionierten Vorfahren
      var offset1 = element1.offset();
      
      if (offset1) {
        // Setzen der Breite von element2 basierend auf der linken Position von element1
        var newWidth = offset1.left;
        element2.css({
          width: newWidth + 'px'
        });
      }
    }
  }
}
  

jQuery(document).ready(function($) {
  // Funktion, um qTranslate-XT Tabs für neue Wiederholungsfelder hinzuzufügen
  $(document).on('cmb2_add_row', function(evt, row) {
      if (row.hasClass('cmb-repeatable-grouping')) {
          row.find('.wp-editor-area').each(function() {
              // Initialize qTranslate-XT on the new editor area
              var editor_id = $(this).attr('id');
              if (typeof qtranx_init_on_textareas != 'undefined') {
                  qtranx_init_on_textareas();
              }
          });
      }
  });

  // Ensure qTranslate-XT tabs are clickable and function correctly
  if (typeof qtranx_init_on_textareas != 'undefined') {
      qtranx_init_on_textareas();
  }
});
